define('views/content/product_categories',['require','views/base/list_page_view','views/components/product_category/product_categories','collections/product_categories','text!templates/content/product_categories.html'],function(require){

    var BaseListPageView = require('views/base/list_page_view');

    var ProductCategoriesView = require('views/components/product_category/product_categories');
    var ProductCategoriesCollection = require('collections/product_categories');

    var temp = require("text!templates/content/product_categories.html");

    return BaseListPageView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'product-category-page',
        titleKey: 'categories',

        setCollection: function () {
            this.collection = new ProductCategoriesCollection();
        },

        onRender: function() {
            this.ListContainer.show(new ProductCategoriesView({
                collection: this.collection
            }));
        }

    });
});
